export default __webpack_public_path__ + "static/media/model_tutorial_mobile.9dd71cc4.png";